module.exports = function() {
  return new Worker(__webpack_public_path__ + "a71c6c99ad0cb884fea4.worker.js");
};